import { createSlice } from "@reduxjs/toolkit";

const initialdatasState = {
  listLoading: false,
  actionsLoading: false,
  residents: null,
  estateDetails: null,
  inviteeDetails: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const ResidentsSlice = createSlice({
  name: "residents",
  initialState: initialdatasState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    disableLoad: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.actionsLoading = false;
    },
    residentsData: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.actionsLoading = false;
      state.residents = action.payload;
    },
    inviteeDetails: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.actionsLoading = false;
      state.inviteeDetails = action.payload;
    },
  }
});
